<template>
  <form id="equipmentVersionForm" class="mx-auto col-sm-8" @submit.prevent>
    <div
      class="form-group"
      :class="{ 'has-error': errors.has('description') }"
    >
      <label for="description">{{ $t("description") }}</label>
      <input
        type="text"
        id="description"
        name="description"
        class="form-control"
        :placeholder="$t('ph_description')"
        v-model="equipmentVersion.VER_DSC"
        v-validate="'required'"
      />

      <small v-show="errors.has('description')" class="form-text">
        {{ errors.first("description") }}
      </small>
    </div>

    <div
      class="form-group"
      :class="{ 'has-error': errors.has('code') }"
    >
      <label for="code">{{ $t("code") }}</label>
      <input
        type="text"
        id="code"
        name="code"
        class="form-control"
        :placeholder="$t('ph_code')"
        v-model="equipmentVersion.VER_COD"
        v-validate="'required'"
      />

      <small v-show="errors.has('code')" class="form-text">
        {{ errors.first("code") }}
      </small>
    </div>

    <div class="form-group row">
      <div class="col-sm-4 col-sm-offset-2">
        <LoaderButton @click="onClick">
          {{ $t("save") }}
        </LoaderButton>
      </div>
    </div>
  </form>
</template>

<script>
import { mapActions } from "vuex";
import LoaderButton from "@/components/button/LoaderButton";

export default {
  name: "ArenaEquipmentVersionForm",
  components: {
    LoaderButton,
  },

  props: {
    equipmentVersion: {
      type: Object,
      default: () => ({
        id: undefined,
        VER_DSC: "",
        VER_COD: undefined
      }),
    },
  },

  methods: {
    ...mapActions("arena", ["createEquipmentVersion", "editEquipmentVersion"]),

    async onClick(evt, done) {
      const valid = await this.$validator.validateAll();
      if (!valid) {
        const err = new Error(this.$t("invalid_form_fields"));

        this.$store.dispatch("notify/error", err);

        return;
      }

      const { id, ...rest } = this.equipmentVersion;

      const result = id
        ? await this.editEquipmentVersion({ id, data: rest })
        : await this.createEquipmentVersion(rest);

      if (result) {
        this.$router.push({ name: "listarenaequipmentversion" });
      }
    },
  }
};
</script>
